import React from 'react';
import { Container } from 'components';

const Posts = () => {
	return (
		<Container title='Posts'>
			<section className='panel'>
				<header className='panel-heading'>
					<div className='panel-actions'>
						<a href='#' className='panel-action panel-action-toggle' data-panel-toggle></a>
						<a href='#' className='panel-action panel-action-dismiss' data-panel-dismiss></a>
					</div>
					<h2 className='panel-title'>Default</h2>
				</header>
				{props.children}
			</section>
		</Container>
	);
}

export default Posts;



// WEBPACK FOOTER //
// ./src/browser/components/posts/posts.js